import { Link } from 'react-router-dom';
import { useAuth } from '../auth/MidwayAuthContext';
import { TabNav } from './TabNav';
import './AppHeader.css';

export function AppHeader() {
  const { user, isAuthenticated, signOut } = useAuth();

  return (
    <header className="app-header">
      <div className="app-header__inner">
        <Link to="/" className="app-header__brand" aria-label="Back to home">
          <div className="app-header__logo" aria-hidden>
            <img
              src="/dap-logo.png"
              alt="DAP-AI logo"
              className="app-header__logo-img"
            />
          </div>
          <div className="app-header__titles">
            <h1 className="app-header__title">DAP-AI</h1>
            <p className="app-header__subtitle">
              Data Automation Platform — Artificial Intelligence
            </p>
          </div>
        </Link>

        <div className="app-header__right">
          <TabNav />
          {isAuthenticated && user && (
            <div className="app-header__user">
              <span className="app-header__user-name">{user.displayName}</span>
              <button
                type="button"
                className="app-header__signout"
                onClick={signOut}
              >
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="app-header__tagline">
        AI-Powered Supplier Quality Management System by ME-SQM
      </div>
    </header>
  );
}
